<template>
  <b-container>
    <b-row>
      <b-col>
        <h2>{{$tr('allPerms','All Perms')}}</h2>
      </b-col>
    </b-row>
    <b-row v-for="perm in perms" :key="perm.name">
      <b-col cols="3" v-html="perm.name"></b-col>
      <b-col cols="2" v-html="perm.code"></b-col>
      <b-col cols="7" v-html="perm.label"></b-col>
    </b-row>
    <b-row>
      <b-col>
        <h2>{{$tr('assignedPerms','Assigned perms')}}</h2>
      </b-col>
    </b-row>
    <b-row v-for="perm in permissionSetEntries" :key="'x-' + perm.name">
      <b-col cols="6" v-html="perm.name"></b-col>
      <b-col cols="6" v-html="perm.val"></b-col>
    </b-row>

  </b-container>
</template>

<script>
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";


export default {
  name: "SessionInfoTab",
  components: {},
  methods:{
  },
  mounted() {
    for(const k in Perms){
      this.perms.push(Perms[k]);
    }

    for(const k in this.permissionSet){
      if(k !== 'handler' && k !=='detached'){
        this.permissionSetEntries.push({name:k, val: this.permissionSet[k]});
      }
    }

  },
  data: () => {
    return {
      perms: [],
      permissionSetEntries:[],
      permissionSet: new PermissionsSet(),
      copiedData:"",
    }
  }
}
</script>
